/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyBorrowStatus
 */
export interface MyBorrowStatus {
    /**
     * 
     * @type {string}
     * @memberof MyBorrowStatus
     */
    status?: MyBorrowStatusStatusEnum;
}


/**
 * @export
 */
export const MyBorrowStatusStatusEnum = {
    AlreadyBorrow: 'ALREADY_BORROW',
    AlreadyReserve: 'ALREADY_RESERVE',
    CanBorrow: 'CAN_BORROW',
    CanReserve: 'CAN_RESERVE'
} as const;
export type MyBorrowStatusStatusEnum = typeof MyBorrowStatusStatusEnum[keyof typeof MyBorrowStatusStatusEnum];


export function MyBorrowStatusFromJSON(json: any): MyBorrowStatus {
    return MyBorrowStatusFromJSONTyped(json, false);
}

export function MyBorrowStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyBorrowStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function MyBorrowStatusToJSON(value?: MyBorrowStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

